const template = `
	<div class="text-lists">
		<div class="lists-box">
			<div class="one-list">
				<div class="list-title">{{ whiteLabel }}</div>
				<textarea v-model="whiteList"></textarea>
			</div>
			<div class="one-list">
				<div class="list-title">{{ blackLabel }}</div>
				<textarea v-model="blackList"></textarea>
			</div>
		</div>
		<div class="bottom-box">
			<span class="link" @click="apply">{{ ii('APPLY') }}</span>
		</div>
	</div>
`;

export default {
	template,
	data() {
		return {
			whiteList: '',
			blackList: '',
		};
	},
	props: ['value', 'white-label', 'black-label'],
	methods: {
		parseValue() {
			if (!this.value) {
				this.whiteList = '';
				this.blackList = '';
				return;
			}
			this.value.split('|').forEach(part => {
				let type = 'whiteList';
				if (part.indexOf('n_') === 0) {
					part = part.slice(2);
					type = 'blackList';
				}
				let val = part.split(',').join('\n');
				this[type] = val;
			});
		},
		apply() {
			let whiteItems = this.whiteList.trim().split(/[\s,]+/);
			let blackItems = this.blackList.trim().split(/[\s,]+/);
			let val = whiteItems.join(',') + '|n_' + blackItems.join(',');
			this.$emit('input', val);
			this.$emit('change', val);
		}
	},
	watch: {
		value() {
			this.parseValue();
		}
	},
	mounted() {
		this.parseValue();
	}
}